import { setSettings } from "store/features/memeGenerator/actions";
import { TextBox } from "store/features/memeGenerator/types";
import { useAppDispatch } from "store/store";

export const useUnderline = (textBox: TextBox) => {
    const isActive = textBox.decoration.underline;
    const dispatch = useAppDispatch();
    function handleClick() {
        dispatch(
            setSettings({
                id: textBox.id,
                decoration: textBox.decoration
                    ? {
                          ...textBox.decoration,
                          underline: !textBox.decoration.underline,
                      }
                    : {
                          underline: true,
                          italic: false,
                          bold: false,
                      },
            }),
        );
    }
    return { isActive, handleClick };
};
